/** Copy of the creditDebitNotes page (Operations), ported from VentaHub. */
export const creditDebitNotes = {
  title: 'Credit / debit notes',
  description: 'Notes issued to or received from vendors, retailers and service providers.',
  empty: 'No credit / debit notes to show',
  emptyHint: 'Nothing matches these filters.',
  filters: {
    warehouse: 'Warehouse',
    text: 'Note number',
    dates: 'Note date',
    void: 'Include voided',
    kind: 'Type',
  },
  kinds: {
    C: 'Credit',
    D: 'Debit',
  },
  columns: {
    number: 'Note number',
    date: 'Note date',
    warehouse: 'Warehouse',
    party: 'Party',
    type: 'Type',
    amountWoVat: 'Excl. VAT',
    amount: 'Amount',
    theirNumber: 'Their number',
    stockUpdateType: 'Stock change',
    linked: 'Linked to',
    comment: 'Comment',
    valid: 'Status',
  },
  modes: {
    S: 'Amounts only',
    N: 'Priced lines, no stock change',
    Y: 'Moves stock',
  },
  links: {
    sales_invoice: 'Sales invoice',
    vendor_invoice: 'Vendor invoice',
    sp_invoice: 'Service provider invoice',
  },
  actions: {
    new: 'New note',
    chooseWarehouseFirst: 'Select a warehouse first.',
    check: 'Check',
    save: 'Save',
    edit: 'Edit',
    void: 'Void',
    download: 'Download note',
  },
  form: {
    hint: 'A credit brings stock back in and lowers what is owed; a debit takes stock out. Check lists anything wrong without saving.',
    choose: 'Choose',
    currency: 'Currency',
    linkKind: 'Linked document',
    linkNumber: 'Document number',
    chooseLinkNumber: 'Choose the linked document',
    noLink: 'None',
    skuCode: 'SKU code',
    boxCode: 'Box code',
    quantity: 'Units',
    price: 'Price per unit',
    vat: 'VAT %',
    linesHint: 'Lines: amounts are worked out from these.',
    stockLinesHint:
      'Lines: a credit puts units into the box (a new box code is created); a debit takes free units out.',
    needHeader:
      'Fill in the warehouse, type, note number, date, a 3-letter currency and the stock change.',
    needAmounts: 'Enter both amounts, as numbers with up to 4 decimals.',
    chooseWarehouse: 'Choose a warehouse.',
    chooseType: 'Choose credit or debit.',
    needNumber: 'Fill in the note number.',
    needDate: 'Choose the note date.',
    badCurrency: 'Type a 3-letter currency code.',
    chooseStockMode: 'Choose the stock change.',
    badAmount: 'Type a number of zero or more, to four decimals.',
    badPrice: 'Line {{line}}: the price must be a number of zero or more, to four decimals.',
    badVat: 'Line {{line}}: VAT must be a percentage from 0 to 100, to two decimals.',
    needLinkNumber: 'Choose the linked document.',
    noLines: 'Add at least one line.',
    badLine:
      'Line {{line}} is incomplete: it needs a SKU code, whole units above zero, a price and a VAT % from 0 to 100.',
    noProblems: 'No problems found. Save when ready.',
    downloadProblems: 'Download problems',
    onLine: 'Line {{line}}: {{message}}',
    saved: 'Note {{code}} saved',
    downloadTemplate: 'Download template',
    uploadFile: 'Upload details from file',
    noFileRows: 'No SKU rows found in the file.',
    cannotReadFile: 'Could not read the file.',
    loaded_one: 'Loaded {{count}} line from the file.',
    loaded_other: 'Loaded {{count}} lines from the file.',
    loadedIncomplete_one: '{{count}} missing a quantity or price',
    loadedIncomplete_other: '{{count}} missing a quantity or price',
  },
  edit: {
    title: 'Edit {{code}}',
    hint: 'Type, stock change, linked document, units and boxes cannot change once saved. To change them, void this note and raise a new one.',
    saved: 'Note {{code}} updated',
  },
  void: {
    title: 'Void {{code}}?',
    creditStock:
      'The units this credit brought in are taken back out of their boxes, and its amount comes off the linked document.',
    debitStock:
      'The units this debit took out go back into their boxes, and its amount comes off the linked document.',
    noStock: 'Its amount comes off the linked document.',
    kept: 'The note stays in the list as voided.',
    done: 'Note {{code}} voided',
  },
  open: 'Open {{code}}',
  lines: {
    title: 'Lines',
    description: 'What is on this document.',
    empty: 'No lines on this document.',
    columns: {
      skuCode: 'SKU',
      skuName: 'Name',
      boxCode: 'Box',
      quantity: 'Quantity',
      amount: 'Amount',
      vatRate: 'VAT %',
    },
  },
} as const
